function applyQuickAddSwatch($swatch, persistSelection) {
  if (!$swatch || !$swatch.length) return;

  var image = $swatch.data('image');
  var value = $swatch.data('value');
  var variant = $swatch.data('variant');
  var price = $swatch.data('price');
  var $container = $swatch.parents('.product-quick-add-container');

  if (value !== undefined) {
    $container.find('.js-swatch-current-selection').text(value);
  }
  if (image) {
    $container.find('#product-quick-add-image').attr('src', image);
  }
  if (variant) {
    $container.find('.product-quick-add-popup-atc.js-product-quick-add').data('id', variant);
    $container.find('.product-quick-add-popup-atc.js-product-quick-add').attr('data-id', variant);
  }
  if (price) {
    $container.find('.js-product-quick-add-price').text(price);
  }
  
  var atcBtn = $container.find('.product-quick-add-popup-atc.js-product-quick-add')[0];
  var swatchEl = $swatch[0];
  if (
    atcBtn &&
    swatchEl &&
    typeof window.syncCollectionQuickAddMonogramState === 'function' &&
    (swatchEl.dataset.isMonogram !== undefined || swatchEl.dataset.forceMonogram !== undefined)
  ) {
    window.syncCollectionQuickAddMonogramState(atcBtn, swatchEl);
  }


  if (persistSelection) {
    $swatch.siblings('.swatch-element').removeClass('selected');
    $swatch.addClass('selected');
  }
}

$(document).on('click', '.product-quick-add-swatch .swatch-element', function(e){
  e.preventDefault();
  e.stopPropagation();
  applyQuickAddSwatch($(this), true);
});

$(document).on('mouseenter', '.product-quick-add-swatch .swatch-element', function(){
  applyQuickAddSwatch($(this), false);
});

$(document).on('mouseleave', '.product-quick-add-swatch .product-quick-add-swatch-options', function(){
  var $selected = $(this).find('.swatch-element.selected').first();
  if ($selected.length) {
    applyQuickAddSwatch($selected, false);
  }
});

$(document).on("click", ".js-open-qa", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $qv = $(".product-quick-add-popup");
  var handle = $(this).data("handle");
  var variant = $(this).data('variant');
  var url = "/products/" + handle + "?view=quick-add"; 
  
  console.log('Quick Add clicked - Handle:', handle, 'Variant:', variant);

  if(variant){
    url += "&variant=" + variant;
    console.log('Quick Add URL with variant:', url);
  } else {
    console.log('Quick Add URL without variant:', url);
  }
  
  $.ajax({
    type: "GET",
    url: url,
    success: function (html) {
      console.log('Quick Add popup content loaded');
      // Prevent inline scripts in the fetched HTML from executing again
      // (can redeclare global constants like ON_CHANGE_DEBOUNCE_TIMER).
      var $html = $('<div>').html(html);
      $html.find('script').remove();
      $qv.find(".product-quick-add-popup-content").html($html.html());
      
      // If a variant was passed, find the corresponding swatch and activate it
      if (variant) {
        console.log('Looking for variant swatch:', variant);
        var $variantSwatch = $qv.find('.js-quick-add-swatch-item[data-id="' + variant + '"]');
        console.log('Variant swatch found:', $variantSwatch.length);
        
        if ($variantSwatch.length) {
          // Remove active class from all swatches
          $qv.find('.js-quick-add-swatch-item').removeClass('active');
          // Add active class to the selected variant swatch
          $variantSwatch.addClass('active');
          // Trigger click to update image, price, etc.
          $variantSwatch.trigger('click');
          console.log('Activated variant swatch:', variant);
        }
      } else {
        // find the already active swatch and set image, price, etc.
        var $activeSwatch = $qv.find('.js-quick-add-swatch-item.active');
        console.log('Active swatches found in popup:', $activeSwatch.length);
        if ($activeSwatch.length) {
          console.log('Triggering click on active swatch');
          $activeSwatch.trigger('click');
        }
      }

      $("html, body").addClass("qa--open");
      window.addEventListener("click",handleClickOutsideQA);
      $qv.addClass("open");
    },
    error: function () {
      window.location.href = $(this).attr("href");
    },
  });
});

$(document).on('click', '.js-product-quick-add-popup-close', function(e){
  quickAddPopupClose();
})

$(document).on('click', '.js-product-quick-add', function(e){
  e.preventDefault();
  e.stopPropagation();

  var $this = $(this);
  if ($this.hasClass('is-sold-out')) return;
   var $card = $this.closest('[data-product-card-item]');
  if ($card && $card.find('[data-product-data] [data-is-gift-card="true"]').length) {
    var productLink = $card.find('a[href*="/products/"]').first().attr('href');
    if (productLink) window.location.href = productLink;
    return;
  }

  var variantId = $this.attr('data-id') || $this.data('id');
  if (!variantId) return;

  $this.prop('disabled', true);
  $this.css('pointer-events', 'none');

  var payload = { id: variantId, quantity: 1 };
  var properties = typeof window.getCollectionQuickAddMonogramProperties === 'function'
    ? window.getCollectionQuickAddMonogramProperties(this)
    : {};
  var preorderNote = $this.attr('data-preorder-note');
  if ($this.hasClass('is-preorder') && preorderNote) {
    properties.Preorder = preorderNote;
  }
  if (Object.keys(properties).length) {
    payload.properties = properties;
  }


  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
      window.theme.cart.getCart();
    }

    var cartDrawer = document.querySelector('cart-drawer, cart-notification');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else if (cartDrawer) {
      cartDrawer.classList.add('active', 'animate');
    }

    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
        if (cartCount) cartCount.textContent = cart.item_count;
      });
  })
  .catch(function() {})
  .finally(function(){
    quickAddPopupClose();
    $this.prop('disabled', false);
    $this.css('pointer-events', '');
    window.removeEventListener("click",handleClickOutsideQA);
  });
});

function quickAddPopupClose(){
  $("html, body").removeClass("qa--open");
  var $qv = $(".product-quick-add-popup");
  $qv.removeClass('open');
}

function handleClickOutsideQA(e){
  if (
    !$(e.target).is(".product-quick-add-popup-content-wrapper *") &&
    $("html").hasClass("qa--open")
  ) {
    quickAddPopupClose();
  }
}